// extracted by mini-css-extract-plugin
module.exports = {"toggle-rtl":"Toggle_toggle-rtl__vLFNH","toggle-ltr":"Toggle_toggle-ltr__16GDQ","p-dir":"Toggle_p-dir__u8y0k"};